import i18next from 'i18next';

const UNITS = ['byte', 'kilobyte', 'megabyte', 'gigabyte', 'terabyte'] as const;
const FALLBACK_LABELS = ['B', 'KB', 'MB', 'GB', 'TB'] as const;

/**
 * Locale-aware byte size formatting (1024-based steps) using Intl unit names.
 */
export function formatBytes(bytes: number, locale?: string): string {
  const raw = Number.isFinite(bytes) ? Math.max(0, bytes) : 0;
  const lng = locale ?? i18next.language ?? 'en';

  let unitIndex = 0;
  let value = raw;
  while (value >= 1024 && unitIndex < UNITS.length - 1) {
    value /= 1024;
    unitIndex += 1;
  }

  const fractionDigits = unitIndex === 0 ? 0 : value >= 100 ? 0 : value >= 10 ? 1 : 1;

  try {
    return new Intl.NumberFormat(lng, {
      style: 'unit',
      unit: UNITS[unitIndex],
      unitDisplay: 'short',
      maximumFractionDigits: fractionDigits,
      minimumFractionDigits: 0,
    }).format(value);
  } catch {
    const rounded = unitIndex === 0 ? String(Math.round(value)) : value.toFixed(fractionDigits);
    return `${rounded} ${FALLBACK_LABELS[unitIndex]}`;
  }
}
